const parseDigits = (string: string) => {
  return (string.match(/\d+/g) || []).join("");
};

export function formatZipCode(value: string, separator: string) {
  const digits = [...parseDigits(value)].entries();
  let result = "";

  for (const [index, digit] of digits) {
    if (index === 5) {
      return result;
    }
    if (index === 2) {
      result = `${result}${separator}`;
    }
    result = `${result}${digit}`;
  }
  return result;
}
